import React, { useEffect, useState } from "react";
import { Paper, TableCell } from "@mui/material";
import { makeStyles } from '@mui/styles';
import {AddAlarm, Edit, Home, Settings, Work} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import EnhancedIconButton from "../enhanced/EnhancedIconButton";
import EnhancedTable from "../enhanced/EnhancedTable";
import EnhancedTableToolbar from "../enhanced/EnhancedTableToolbar";
import UserCompanyDialog from "./UserCompanyDialog";
import UserDialog from "./UserDialog";
import UserSpecialEditDialog from "./UserSpecialEditDialog";
import { fetchUserListByCompanyId, fetchUserProfileTypes } from "../../features/usersSlice";
import { fetchAclRoles } from "../../features/listsSlice";
import UserAttendanceSettingsDialog from "./UserAttendanceSettingsDialog";
import UserAddAttendanceWorkDayDialog from "./UserAddAttendanceWorkDayDiallog";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EnhancedTableIconButton from "../enhanced/EnhancedTableIconButton";

function UserTable() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const userList = useSelector((state) => state.users.userList);

  const [openSpecialEdit, setOpenSpecialEdit] = useState(false);
  const [openCompanyUser, setOpenCompanyUser] = useState(false);
  const [openAttendanceSettings, setAttendanceSettings] = useState(false);
  const [openAddAttendanceWorkingDay, setAddAttendanceWorkingDay] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});

  useEffect(() => {
    dispatch(fetchUserListByCompanyId());
    dispatch(fetchAclRoles());
    dispatch(fetchUserProfileTypes());
  }, [dispatch]);

  const headerList = [
    { align: "left", label: "" },
    { align: "right", label: "ID" },
    { align: "right", label: "Jméno" },
    { align: "right", label: "Email" },
    { align: "right", label: "Telefon" },
    { align: "right", label: "Role" },
    { align: "right", label: "Aktivní" }
  ];

  function handleEdit(user) {
    setSelectedUser(user);
    setOpenEdit(true);
  }

  function handleSpecialEdit(user) {
    setSelectedUser(user);
    setOpenSpecialEdit(true);
  }

  function handleCompanyUser(user) {
    setSelectedUser(user);
    setOpenCompanyUser(true);
  }

  function handleAttendanceSettings(user) {
    setSelectedUser(user);
    setAttendanceSettings(true);
  }

  function handleAddAttendanceWorkingDay(user) {
    setSelectedUser(user);
    setAddAttendanceWorkingDay(true);
  }

  const renderRowCells = (user) => (
    <>
      <TableCell>
        <EnhancedTableIconButton
          authority="user.edit"
          ariaLabel="edit row"
          size="small"
          tooltip="Upravit"
          Icon={Edit}
          onClick={() => handleEdit(user)}
        />
        <EnhancedTableIconButton
          authority="user.all"
          ariaLabel="profile row"
          size="small"
          tooltip="Nastavení"
          Icon={Settings}
          onClick={() => handleSpecialEdit(user)}
        />
        <EnhancedTableIconButton
          authority="user.all"
          ariaLabel="organization row"
          size="small"
          tooltip="Nastavení organizace"
          Icon={Home}
          onClick={() => handleCompanyUser(user)}
        />
        <EnhancedTableIconButton
          authority="user.all"
          ariaLabel="attendance row"
          size="small"
          tooltip="Nastavení docházky"
          Icon={Work}
          onClick={() => handleAttendanceSettings(user)}
        />
        <EnhancedTableIconButton
          authority="user.all"
          ariaLabel="attendance row"
          size="small"
          tooltip="Přidat pracovní den"
          Icon={AddAlarm}
          onClick={() => handleAddAttendanceWorkingDay(user)}
        />
      </TableCell>
      <TableCell align="right">{user["id"]}</TableCell>
      <TableCell align="right">{user["fullName"]}</TableCell>
      <TableCell align="right">{user["email"]}</TableCell>
      <TableCell align="right">{user["phone"]}</TableCell>
      <TableCell align="right">{user["roles"]}</TableCell>
      <TableCell align="right">
        {user["active"] === 'true' ?
            <CheckCircleOutlineIcon color={"primary"} />
             :
            <HighlightOffIcon color={"error"} />
      }</TableCell>
    </>
  );

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar authority="user.edit" label="Uživatelé" setOpenNew={setOpenNew} addible />
        <EnhancedTable headerList={headerList} dataList={userList} renderRowCells={renderRowCells} />
      </Paper>
      <UserSpecialEditDialog user={selectedUser} open={openSpecialEdit} setOpen={setOpenSpecialEdit} />
      <UserDialog
        user={selectedUser}
        openNew={openNew}
        openEdit={openEdit}
        setOpenEdit={setOpenEdit}
        setOpenNew={setOpenNew}
      />
      <UserCompanyDialog user={selectedUser} open={openCompanyUser} setOpen={setOpenCompanyUser} />
      <UserAttendanceSettingsDialog user={selectedUser} open={openAttendanceSettings} setOpen={setAttendanceSettings} />
      <UserAddAttendanceWorkDayDialog user={selectedUser} open={openAddAttendanceWorkingDay} setOpen={setAddAttendanceWorkingDay} />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%"
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2)
  }
}));

export default UserTable;
